import styled from 'styled-components'

const Body = styled('div')`
  height: calc(100% - 64px);
`

export default Body
